import { __awaiter } from 'tslib';
import 'long';
import { im_proto } from '../../proto/index.js';
import { IMEvent } from '../../core/consts.js';
import { Logger } from '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import { ServiceIdentity } from '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import { BaseProcessor } from '../../core/service/processor/BaseProcessor.js';
import '../../core/model/CommandMessage.js';

class PropertyCmdProcessor extends BaseProcessor {
    process(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.data.type === im_proto.MessageType.MESSAGE_TYPE_UPDATE_MESSAGE_PROPERTY) {
                item.needContinue = false;
                yield this.handlePropertyCmd(item.data);
            }
            return item;
        });
    }
    handlePropertyCmd(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const localMsg = this.resolve(ServiceIdentity.MessageManager).getRaw(msg.conversationId, msg.clientId);
            if (localMsg) {
                localMsg.version = msg.version;
                Logger.ctxDebug(this.ctx, 'merge property, local:', localMsg.property, 'server:', msg.property);
                // use server property
                localMsg.property = msg.property;
                this.resolve(ServiceIdentity.MessageManager).upsert(localMsg);
                this.resolve(ServiceIdentity.EventBus).emit(IMEvent.MessagePropertyUpsert, this, localMsg);
            }
            else {
                Logger.ctxDebug(this.ctx, 'modify property cmd msg not exist in local', msg);
            }
        });
    }
}

export { PropertyCmdProcessor };
//# sourceMappingURL=PropertyCmdProcessor.js.map
